/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BillingCouponCode } from './BillingCouponCode';
import {
    BillingCouponCodeFromJSON,
    BillingCouponCodeFromJSONTyped,
    BillingCouponCodeToJSON,
    BillingCouponCodeToJSONTyped,
} from './BillingCouponCode';
import type { BillingCoupon } from './BillingCoupon';
import {
    BillingCouponFromJSON,
    BillingCouponFromJSONTyped,
    BillingCouponToJSON,
    BillingCouponToJSONTyped,
} from './BillingCoupon';

/**
 * 
 * @export
 * @interface BillingCouponRedemption
 */
export interface BillingCouponRedemption {
    /**
     * 
     * @type {number}
     * @memberof BillingCouponRedemption
     */
    id: number;
    /**
     * 
     * @type {Date}
     * @memberof BillingCouponRedemption
     */
    fullyRedeemedAt: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof BillingCouponRedemption
     */
    createdAt: Date;
    /**
     * 
     * @type {BillingCouponCode}
     * @memberof BillingCouponRedemption
     */
    billingCouponCode: BillingCouponCode;
    /**
     * 
     * @type {BillingCoupon}
     * @memberof BillingCouponRedemption
     */
    billingCoupon: BillingCoupon;
}

/**
 * Check if a given object implements the BillingCouponRedemption interface.
 */
export function instanceOfBillingCouponRedemption(value: object): value is BillingCouponRedemption {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('fullyRedeemedAt' in value) || value['fullyRedeemedAt'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('billingCouponCode' in value) || value['billingCouponCode'] === undefined) return false;
    if (!('billingCoupon' in value) || value['billingCoupon'] === undefined) return false;
    return true;
}

export function BillingCouponRedemptionFromJSON(json: any): BillingCouponRedemption {
    return BillingCouponRedemptionFromJSONTyped(json, false);
}

export function BillingCouponRedemptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): BillingCouponRedemption {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'fullyRedeemedAt': (json['fullyRedeemedAt'] == null ? null : new Date(json['fullyRedeemedAt'])),
        'createdAt': (new Date(json['createdAt'])),
        'billingCouponCode': BillingCouponCodeFromJSON(json['billingCouponCode']),
        'billingCoupon': BillingCouponFromJSON(json['billingCoupon']),
    };
}

  export function BillingCouponRedemptionToJSON(json: any): BillingCouponRedemption {
      return BillingCouponRedemptionToJSONTyped(json, false);
  }

  export function BillingCouponRedemptionToJSONTyped(value?: BillingCouponRedemption | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'fullyRedeemedAt': (value['fullyRedeemedAt'] == null ? null : (value['fullyRedeemedAt'] as any).toISOString()),
        'createdAt': ((value['createdAt']).toISOString()),
        'billingCouponCode': BillingCouponCodeToJSON(value['billingCouponCode']),
        'billingCoupon': BillingCouponToJSON(value['billingCoupon']),
    };
}

